import React from 'react';
import PropTypes from 'prop-types';
import Authorization from 'containers/Authorization';
import { Button, Dropdown } from 'react-bootstrap';
import cx from 'classnames';
import { FACILITY_PAGES, NON_FACILITY_PAGES, BUILDER } from 'shared/abilities';
import style from './PageListActions.scss';
import { renderOverlay } from '.';

const propTypes = {
  page: PropTypes.object.isRequired,
  asTopMenuOpt: PropTypes.bool,
  singleBtn: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  disabledRow: PropTypes.bool.isRequired,
};

const EditAction = ({
  page, asTopMenuOpt, singleBtn, onClick, disabledRow,
}) => {
  const { facilityId, companyId } = page;
  const subject = facilityId ? [BUILDER, FACILITY_PAGES] : [BUILDER, NON_FACILITY_PAGES];
  return (
    <Authorization action="manage" subject={subject} facilityId={facilityId} companyId={companyId}>
      {(authorized) => {
        const auth = authorized && !disabledRow;

        return renderOverlay({
          authorized: auth,
          action: 'edit',
          option: asTopMenuOpt ? (
            <span className={cx(style.topBtnWrapper, { [style.disabledBtnWrapper]: !auth })}>
              <Button
                variant="default"
                onClick={onClick}
                className={cx(style.topBtn, { [style.singleBtn]: singleBtn, [style.disabledBtn]: !auth })}
              >
                Edit
              </Button>
            </span>
          ) : (
            <Dropdown.Item
              onClick={onClick}
              disabled={!auth}
              className={cx(style.actionMenuItem, { [style.disabledItem]: !auth })}
            >
            Edit
            </Dropdown.Item>
          ),
        });
      }}
    </Authorization>
  );
};

EditAction.propTypes = propTypes;

export default EditAction;
